const GTAG_ID = 'G-51QJRHYL1Q';
const GTAG_ID_NEW = 'G-JPPZ5DYSTV';
const TRANSPORT_URL = 'https://blackhole.lun.ua';

const getContentGroup = (chipId) => {
  const isMap = window.params.type === 'map';
  const base = isMap ? 'map' : 'catalog';

  if (chipId === 'new_building' || chipId === 'cottage') {
    return `${base}_${chipId}`;
  }

  return base;
};

export const sendRealtyTypePageViewEvents = (chipId) => {
  const configData = {
    transport_url: TRANSPORT_URL,
    first_party_collection: true,
    send_page_view: false,
    content_group: getContentGroup(chipId),
  };

  gtag('config', GTAG_ID, configData);

  gtag('event', 'page_view', {
    pageType: window.eventCategory,
    send_to: GTAG_ID,
    page_location: window.location.href,
    backendSplitTestVersion: window.splitTestVersion,
    ...window.analyticsData,
  });

  gtag('config', GTAG_ID_NEW, {
    language: window.currentLanguage === 'uk' ? 'uk' : 'ru',
    backendSplitTestVersion: window.splitTestVersion,
    pageType: window.eventCategory,
    ...configData,
    ...window.analyticsData,
  });

  gtag('event', 'page_view', {
    route_to_new_ga4: true,
    page_location: window.location.href,
    page_referrer: window.dataLayer[0].http_referrer,
  });
};

export const sendRealtyTypeClickEvents = (type) => {
  gtag('event', 'click', {
    route_to_new_ga4: true,
    element_code: 'catalog_section_chip',
    element_type: 'button',
    destination: type,
  });
};
